module.exports = __webpack_public_path__ + "682f83ccb7abb7cf0629648283dc0c98.svg";